import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {ValueTitleObject} from '../../../CommonInterfaces/IIdNameObject';
import {apiRequestHelper} from '../../../Helpers/ApiRequestHelper';
import {responseToIdNameOptions} from './Helpers/responseToIdNameOptions';

/**
 * Build dropdown for Entity.
 *
 * @param {string} action
 * @param gender
 * @param event
 * @param setEvent
 * @param config axios request config forwarded to the list request (e.g. `{params: {...}}`)
 * @returns {(props: IFilterGenerator) => React.ReactElement}
 * @constructor
 */
export function buildEntityDropdown(
  action: string, gender = 0, event: string, setEvent: any, config?: any) {
  return (): React.ReactElement => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [options, setOptions] = useState<ValueTitleObject[]>(
      []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      let isSubscribed = true;
      const responseHandler = (response: any) => {
        if (!isSubscribed) {
          return;
        }
        responseToIdNameOptions(response, setOptions);
      };
      apiRequestHelper({
        action: action, responseHandler, config,
      });
      return () => {
        isSubscribed = false;
      };
    }, []);

    /**
     * Apply filtered value to table.
     * @param {React.ChangeEvent} e
     */
    function handleChange(e: React.ChangeEvent<{ value: unknown }>) {
      const val = e.target.value as string;
      setEvent(val);
    }

    const id = 'event';

    return (
      <React.Fragment>
        <FormControl fullWidth>
          <InputLabel id={`${id}-label`}>Мероприятие</InputLabel>
          <Select
            labelId={`${id}-label`}
            fullWidth
            value={event}
            onChange={handleChange}>
            {options.map(Option)}
          </Select>
        </FormControl>
      </React.Fragment>
    );
  };
}

const Option = (el: ValueTitleObject) => {
  return <MenuItem key={el.value} value={el.value}>{el.title}</MenuItem>;
};
